import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@app/api/auth/useAuth';
import { withAuthLang } from '@app/i18n';
import AuthLayout from '@shared/ui/auth/AuthLayout';
import { ThemeButton } from '@shared/ui/buttons';
import { EmailInput } from '@shared/ui/forms/inputs';
import { isEmptyObject } from '@utils/helpers';
import { validateServerErrors } from '@utils/validation';

export default function ForgotPasswordPage() {
  const [isSuccess, setIsSuccess] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { forgotPassword } = useAuth();
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({ mode: 'onChange', defaultValues: { email: '' } });

  async function onSubmit(data) {
    try {
      const res = await forgotPassword(data);
      if (res) setIsSuccess(true);
    } catch (error) {
      validateServerErrors(setError, error);
    }
  }

  return (
    <AuthLayout>
      {!isSuccess ? (
        <form className="auth__block" onSubmit={handleSubmit(onSubmit)}>
          <div className="block-pd-x block-pd-y">
            <img
              className="auth__icon"
              src="/images/forgot-password.png"
              alt="forgot password"
              width={96}
              height={96}
            />
            <h2 className="title-h2m">{t('forgot_password')}</h2>
            <p className="auth__subtitle">{t('forgot_password_subtitle')}</p>
            <div className="form">
              <EmailInput errors={errors} control={control} />
            </div>
          </div>
          <div className="dialog-actions btns-toolbar">
            <ThemeButton
              type="submit"
              endIcon="send"
              disabled={!isEmptyObject(errors)}
              loading={isSubmitting}
            >
              {t('send')}
            </ThemeButton>
            <ThemeButton
              appearance="secondary"
              startIcon="chevron-left"
              onClick={() => navigate(withAuthLang('/login'))}
            >
              {t('back_to_login')}
            </ThemeButton>
          </div>
        </form>
      ) : (
        <div className="auth__block">
          <div className="block-pd-x block-pd-y">
            <img
              className="auth__icon email-sent"
              src="/images/email-sent.png"
              alt="email sent"
              width={300}
              height={136}
            />
            <h2 className="title-h2m">{t('email_sent')}</h2>
            <p className="auth__subtitle">
              {t('forgot_password_email_sent_1')}
            </p>
            <p
              className="auth__subtitle"
              dangerouslySetInnerHTML={{ __html: t('email_sent_3') }}
            ></p>
          </div>
          <div className="dialog-actions btns-toolbar">
            <ThemeButton
              startIcon="chevron-left"
              onClick={() => navigate(withAuthLang('/login'))}
              minWidth
              block={false}
            >
              {t('back_to_login')}
            </ThemeButton>
          </div>
        </div>
      )}
    </AuthLayout>
  );
}
